"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperOrganizationScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _uploadStandaloneFile = require('web/services/uploadStandaloneFile');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _alertReducer = require('shared/reducers/alertReducer');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _SuperTableTR = require('web/components/Super/SuperTableTR'); var _SuperTableTR2 = _interopRequireDefault(_SuperTableTR);
var _SuperMoveUserToAnotherOrgModal = require('web/screens/Super/SuperMoveUserToAnotherOrgModal'); var _SuperMoveUserToAnotherOrgModal2 = _interopRequireDefault(_SuperMoveUserToAnotherOrgModal);




var _SuperSubscriptions = require('web/screens/Super/SuperSubscriptions');
var _SuperTeamModal = require('./SuperTeamModal'); var _SuperTeamModal2 = _interopRequireDefault(_SuperTeamModal);
var _SuperTeamTable = require('web/components/Super/SuperTeamTable'); var _SuperTeamTable2 = _interopRequireDefault(_SuperTeamTable);
var _Tt = require('web/screens/Super/Tt'); var _Tt2 = _interopRequireDefault(_Tt);
var _untypedAlert = require('web/screens/Super/untypedAlert');
var _uuid = require('shared/services/uuid');
var _log = require('shared/log');
var _supportChat = require('web/screens/Super/supportChat');
var _formHelpers = require('web/screens/Super/formHelpers');
var _MoreToggle = require('web/components/RightSide/Header/MoreToggle'); var _MoreToggle2 = _interopRequireDefault(_MoreToggle);
var _Tooltip = require('web/components/Tooltip');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');


















const stopPropagation = (e) => e.stopPropagation()

// The first subscription in a subscription command's answer, or undefined
// when there is none (as `Object.keys(result).map(k => result[k])[0]` was).
const firstSubscription = (result) => Object.values(result)[0]







const UserResult = (props) => {
  const relatedOrgOrUndefined = Object.values(props.user.Relationships).find((rel) => rel.OrgKey === props.orgKey)
  const canOpenSupportChat = props.user.Activated && !props.user.Deleted && !_optionalChain([relatedOrgOrUndefined, 'optionalAccess', _ => _.Pending])
  // SAFETY: kept from the class: a member without a relationship to this
  // org throws on `.Title` below.
  const relatedOrg = relatedOrgOrUndefined 
  return (
      _react2.default.createElement(_SuperTableTR2.default, { to: `/super/users/${props.user.UserKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
        , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}, props.user.UserKey)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}, props.user.FirstName)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, props.user.LastName)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}, relatedOrg.Title)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, relatedOrg.Type)
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}, relatedOrg.Pending ? 'yes' : 'no')
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}, props.user.Activated ? 'yes' : 'no')
        , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}, props.user.Deleted ? 'yes' : 'no')
        , _react2.default.createElement('td', { onMouseDown: stopPropagation, onMouseUp: stopPropagation, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
          ,  canOpenSupportChat ? (
            _react2.default.createElement(_MoreToggle2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
              , _react2.default.createElement(_Tooltip.TooltipMenuItem, {
                iconSrc: "/assets/icons/video/message-black.svg",
                label: "Open support chat"  ,
                onClick: () => props.openSupportChat(props.user.UserKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
              )
            )
          ) : null
        )
      )
  )
}






const PatientResult = (props) => {
  return (
      _react2.default.createElement(_SuperTableTR2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
        , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}, props.patient.PatientKey)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, props.patient.ForeignID)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}, props.patient.FirstName)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}, props.patient.LastName)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}, props.patient.DateOfBirth)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}, props.patient.Phone)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}, props.patient.Email)
        , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
          , _react2.default.createElement('button', { onClick: () => props.delete(), className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}, "Delete")
        )
      )
  )
}

const RelationshipResult = (props) => {
  return (
    _react2.default.createElement(_SuperTableTR2.default, { to: `/super/orgs/${props.relationship.TrustedOrgKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}
      , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}, props.relationship.TrustedOrgKey)
    )
  )
}









const SuperPhoneChooser = ({ orgKey, open, onClose }) => {
  const [numbers, setNumbers] = _react.useState([])
  const [selectedNumber, setSelectedNumber] = _react.useState(null)
  // An instance field in the class: typing doesn't re-render.
  const searchText = _react.useRef(undefined)

  const handleClose = () => {
    if (onClose) {
      onClose()
    }
  }

  const changeSearchText = (evt) => {
    searchText.current = evt.target.value
  }

  const search = () => {
    // SAFETY: as in the class, an untouched field sends no AreaCode.
    _client2.default.send('GetAvailablePhoneNumbers', { AreaCode: searchText.current  })
      .then((results) => {
        setNumbers(results.AvailableNumbers.slice(0, 10))
        setSelectedNumber(null)
      }).catch(_log.log.error)
  }

  const radioChecked = (evt) => {
    setSelectedNumber(evt.target.value)
  }

  const handleSubmit = () => {
    _client2.default.send("SUPER_BuyPhoneForOrg", {
      OrgKey: orgKey,
      PhoneNumber: selectedNumber,
    }).then(() => {
      handleClose()
    }).catch(_log.log.error)
  }

  const numberRows = numbers.map((number) => (
      _react2.default.createElement('div', { key: number.PhoneNumber, __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}
        , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}
          , _react2.default.createElement('input', { type: "radio", name: "phone", value: number.PhoneNumber, onChange: radioChecked,
                 checked: selectedNumber === number.PhoneNumber, __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}}), " " , number.PhoneNumber
        )
      )
  ))

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: handleClose,
      title: "Issue Number" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}

      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
        , _react2.default.createElement('input', {
          type: "text",
          placeholder: "Area code" ,
          onChange: changeSearchText, __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
        )
        , _react2.default.createElement('input', {
          type: "submit",
          value: "Search",
          onClick: search, __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
        )
      )
      , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 191}}
        , numberRows
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: handleClose,
        primaryBtnLabel: "Submit",
        // The class passed the number itself; ModalControls only tests it.
        isPrimaryEnabled: !!selectedNumber,
        onPrimaryBtnClick: handleSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}
      )
    )
  )
}












// Mounted for every phone row, so the selection survives closing the modal,
// as the class's state did.
const SuperTeamPhoneAssigned = ({
  isOpen, orgTeams, phoneKey, teamKey, onClose, onSuccess,
}) => {
  const [selectedTeam, setSelectedTeam] = _react.useState(teamKey)

  const handleClose = () => {
    onClose()
  }

  const radioChecked = (evt) => {
    // SAFETY: the radio values are team keys or EMPTY_BLUID.
    setSelectedTeam(evt.target.value )
  }

  const handleSubmit = () => {
    _client2.default.send("SUPER_AssignPhoneToTeam", {
      TeamKey: selectedTeam,
      PhoneKey: phoneKey,
    }).then(() => {
      handleClose()
      onSuccess()
    }).catch(_log.log.error)
  }

  const teams = Object.values(orgTeams).map((team) => (
      _react2.default.createElement('div', { key: team.TeamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}
        , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 245}}
          , _react2.default.createElement('input', { type: "radio", name: "team", value: team.TeamKey, onChange: radioChecked,
                 checked: selectedTeam === team.TeamKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}), " " , team.Name
        )
      )
  ))

  teams.push(
      _react2.default.createElement('div', { key: 'hello_yotam', __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}
        , _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}
          , _react2.default.createElement('input', {
              type: "radio",
              name: "team",
              value: _uuid.EMPTY_BLUID,
              onChange: radioChecked,
              checked: selectedTeam === _uuid.EMPTY_BLUID, __self: this, __source: {fileName: _jsxFileName, lineNumber: 255}}
          ), "*** NONE ***"

        )
      ),
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: handleClose,
      title: "Assign Number" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}

      ,  teams 
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: handleClose,
        primaryBtnLabel: "Submit",
        isPrimaryEnabled: !!selectedTeam,
        onPrimaryBtnClick: handleSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}
      )
    )
  )
}

// The route renders this screen through `render`, so params arrive untyped.


// Memoized, as connect() was. The route keys this screen by org key, so a
// different org remounts it and orgKey is fixed for its lifetime.
const SuperOrganizationScreen = _react.memo.call(void 0, function SuperOrganizationScreen ({ match }) {
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)
  // SAFETY: the route param is an org key.
  const orgKey = match.params.orgKey 

  const [teamPhoneAssignerOpen, setTeamPhoneAssignerOpen] = _react.useState.call(void 0, false)
  const [teamPhoneAssignerNumber, setTeamPhoneAssignerNumber] = _react.useState(null)
  const [phoneChooserOpen, setPhoneChooserOpen] = _react.useState.call(void 0, false)
  const [updateSubscriptionModalOpen, setUpdateSubscriptionModalOpen] = _react.useState.call(void 0, false)
  const [attachOrgToSubscriptionModalOpen, setAttachOrgToSubscriptionModalOpen] = _react.useState.call(void 0, false)
  const [subscriptionOrgSettingsModalOpen, setSubscriptionOrgSettingsModalOpen] = _react.useState.call(void 0, false)
  const [overageExemptModalOpen, setOverageExemptModalOpen] = _react.useState.call(void 0, false)
  const [createTeamModalOpen, setCreateTeamModalOpen] = _react.useState.call(void 0, false)
  const [deletePatientModalOpen, setDeletePatientModalOpen] = _react.useState.call(void 0, false)
  const [moveUserModalOpen, setMoveUserModalOpen] = _react.useState.call(void 0, false)
  const [patientToDelete, setPatientToDelete] = _react.useState(null)
  // null before it loads; undefined after a subscription command answers
  // with none, as the class stored.
  const [subscription, setSubscription] = _react.useState(null)
  const [org, setOrg] = _react.useState(undefined)
  const [users, setUsers] = _react.useState([])
  const [patients, setPatients] = _react.useState([])
  const [teams, setTeams] = _react.useState({})
  const [phones, setPhones] = _react.useState({})
  const [relationships, setRelationships] = _react.useState([])

  // Instance fields in the class: the bulk forms' inputs, which don't re-render.
  const invitedBy = _react.useRef(undefined)
  const userList = _react.useRef(undefined)
  const patientList = _react.useRef(undefined)
  const patientImportedBy = _react.useRef(undefined)

  const loadTeams = _react.useCallback.call(void 0, () => {
    _client2.default.send('SUPER_GetTeamsForOrg', { OrgKey: orgKey }).then((t) => {
      setTeams(t.Teams || {}) // Some orgs don't have teams
    }).catch(_log.log.error)
  }, [orgKey])

  const loadOrg = _react.useCallback.call(void 0, () => {
    _client2.default.send('SUPER_GetOrg', { OrgKey: orgKey })
      .then((results) => {
        setOrg(results.Org)
        setPhones(results.Phones)
      }).catch(_log.log.error)
  }, [orgKey])

  const loadUsers = () => {
    _client2.default.send('SuperUsersByOrg', { OrgKey: orgKey })
      .then((results) => {
        setUsers(Object.values(results))
      }).catch(_log.log.error)
  }

  const loadPatients = () => {
    _client2.default.send('FindPatientsInOrg', { OrgKey: orgKey, Limit: 100 })
      .then((results) => {
        setPatients(Object.values(results.Patients))
      }).catch(_log.log.error)
  }

  const loadRelationships = () => {
    _client2.default.send('SUPER_GetOrgRelationships', { OrgKey: orgKey })
      .then((results) => {
        setRelationships(Object.values(results.OrgRelationships).filter((rel) => !rel.Deleted))
      }).catch(_log.log.error)
  }

  const loadSubscription = () => {
    _client2.default.send('SUPER_GetSubscription', { OrgKey: orgKey })
      .then((result) => {
        if (Object.keys(result).length > 0) {
          setSubscription(firstSubscription(result))
        }
      }).catch(err => _log.log.error(err))
  }

  const load = () => {
    loadTeams()
    loadOrg()
    loadUsers()
    loadPatients()
    loadRelationships()
    loadSubscription()
  }

  // Loads once, on mount, like componentDidMount.
  _react.useEffect.call(void 0, () => {
    load()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const updateInviteBy = (evt) => {
    invitedBy.current = evt.target.value
  }
  const updateUserList = (evt) => {
    // SAFETY: as in the class, which read files[0] of the change event.
    userList.current = (evt.target.files )[0]
  }
  const updatePatientList = (evt) => {
    // SAFETY: as above.
    patientList.current = (evt.target.files )[0]
  }
  const updateImportedBy = (evt) => {
    patientImportedBy.current = evt.target.value
  }

  const bulkInvite = (evt) => {
    evt.preventDefault()
    // A missing file still goes to /upload_file, which rejects it, as before.
    _uploadStandaloneFile.uploadStandaloneFile.call(void 0, userList.current)
      .then((Metadata) => {
        _client2.default.send('SuperBulkInvite', {
          OrgKey: orgKey,
          // SAFETY: typed in by a super user; the backend validates it.
          UserKey: invitedBy.current ,
          FileKey: Metadata.FileKey,
        }).then(() => {
          _actions2.default.pushAlert("Success", "Successfully invited users", _alertReducer.AlertTypes.SUCCESS)
        }).catch(_log.log.error)
      })
  }

  const bulkPatientImport = (evt) => {
    evt.preventDefault()
    const importedBy = (_nullishCoalesce(patientImportedBy.current, () => ( ''))).trim()
    // SuperPatientImport requires the importing user's key (`validate:"uuid4"`).
    if (!_formHelpers.isUuid4.call(void 0, importedBy)) {
      _actions2.default.pushAlert("Error", "Enter the user key of the user importing the patients", _alertReducer.AlertTypes.ERROR)
      return
    }
    _actions2.default.pushAlert("Uploading file", "Please wait", _alertReducer.AlertTypes.INFORMATION)
    // A missing file still goes to /upload_file, which rejects it, as before.
    _uploadStandaloneFile.uploadStandaloneFile.call(void 0, patientList.current)
      .then((Metadata) => {
        _actions2.default.pushAlert("Beginning Import", "Beginning patient import. Please wait for notification complete", _alertReducer.AlertTypes.INFORMATION)
        return _actions2.default.superPatientImport({
          OrgKey: orgKey,
          // SAFETY: checked above to be a key; the backend checks the user exists.
          UserKey: importedBy ,
          FileKey: Metadata.FileKey,
        })
      })
      .then((response) => {
        _log.log.info("PATIENT IMPORT STATS", response)
        _actions2.default.pushAlert("Job Completed", `Rows success: ${response.RowsSuccess}. Rows failure: ${response.RowsFailure}.`, _alertReducer.AlertTypes.INFORMATION)
      })
      .catch((err) => {
        _actions2.default.pushAlert("Error", _formHelpers.errorMessage.call(void 0, err), _alertReducer.AlertTypes.ERROR)
        _log.log.error(err)
      })
  }

  const openPhoneChooser = () => setPhoneChooserOpen(true)
  const closePhoneChooser = () => {
    setPhoneChooserOpen(false)
    load()
  }

  const removePhone = (phoneKey) => {
    _client2.default.send("SUPER_DeleteOrgPhone", {
      PhoneKey: phoneKey,
    }).then(() => {
      load()
    }).catch(_log.log.error)
  }

  const openCreateTeamModal = _react.useCallback.call(void 0, () => {
    setCreateTeamModalOpen(true)
  }, [])

  const closeCreateTeamModal = _react.useCallback.call(void 0, () => {
    setCreateTeamModalOpen(false)
  }, [])

  const createTeam = (teamName) => {
    return _client2.default.send('CreateTeamAtOrg', { OrgKey: orgKey, TeamName: teamName }).then(() => {
      loadTeams()
    }).catch(_log.log.error)
  }

  const deletePatient = () => {
    return _client2.default.send('SUPER_DeletePatient', {
      PatientKey: patientToDelete,
    }).then(() => {
      _actions2.default.pushAlert("Success", "Patient deleted", _alertReducer.AlertTypes.SUCCESS)
      setPatientToDelete(null)
      setDeletePatientModalOpen(false)
      load()
    }).catch(err => {
      _untypedAlert.pushUntypedAlert.call(void 0, "Failure", "Failed to delete patient")
      _log.log.error(err)
    })
  }

  const closeOverageExemptModal = _react.useCallback.call(void 0, () => {
    setOverageExemptModalOpen(false)
  }, [])

  const closeUpdateSubscriptionModal = _react.useCallback.call(void 0, () => {
    setUpdateSubscriptionModalOpen(false)
  }, [])

  const closeAttachOrgToSubscriptionModal = _react.useCallback.call(void 0, () => {
    setAttachOrgToSubscriptionModalOpen(false)
  }, [])

  const closeSubscriptionOrgSettingsModal = _react.useCallback.call(void 0, () => {
    setSubscriptionOrgSettingsModalOpen(false)
  }, [])

  const updateSubscription = (subscriptionKey, stripeCustomerID, stripeSubscriptionID) => {
    _client2.default.send('SUPER_UpdateStripeDetailsForSubscription', {
      SubscriptionKey: subscriptionKey,
      StripeCustomerID: stripeCustomerID,
      StripeSubscriptionID: stripeSubscriptionID,
    }).then((result) => {
      _actions2.default.pushAlert("Success", "Stripe Subscription Updated", _alertReducer.AlertTypes.SUCCESS)
      setSubscription(firstSubscription(result))
      closeUpdateSubscriptionModal()
    }).catch(err => {
      _untypedAlert.pushUntypedAlert.call(void 0, "Failure", "Failed to update subscription")
      _log.log.error(err)
    })
  }

  const attachOrgToNewSubscription = (orgToAttach, orgOwner) => {
    _client2.default.send('SUPER_AttachOrgToExistingSubscription', {
      OrgToAttach: orgToAttach,
      OrgOwner: orgOwner,
    }).then((result) => {
      _actions2.default.pushAlert("Success", "Org attached to new owner", _alertReducer.AlertTypes.SUCCESS)
      setSubscription(firstSubscription(result))
      closeAttachOrgToSubscriptionModal()
    }).catch(err => {
      _untypedAlert.pushUntypedAlert.call(void 0, "Failure", "Failed to attach to new org")
      _log.log.error(err)
    })
  }

  const updateSubscriptionOrgSettings = (subscriptionKey, settingsOrgKey, professional, patientMessaging) => {
    _client2.default.send('SUPER_UpdateSubscriptionOrgSettings', {
      SubscriptionKey: subscriptionKey,
      OrgKey: settingsOrgKey,
      BloomTextPro: professional,
      PatientMessaging: patientMessaging,
    }).then((result) => {
      _actions2.default.pushAlert("Success", "Org settings updated", _alertReducer.AlertTypes.SUCCESS)
      setSubscription(firstSubscription(result))
      closeSubscriptionOrgSettingsModal()
    }).catch(err => {
      _untypedAlert.pushUntypedAlert.call(void 0, "Failure", "Failed to update org settings")
      _log.log.error(err)
    })
  }

  const setSubscriptionOverageExempt = (subscriptionKey, overageExempt) => {
    _client2.default.send('SUPER_SetSubscriptionOverageExempt', {
      SubscriptionKey: subscriptionKey,
      OverageExempt: overageExempt,
    }).then((result) => {
      _actions2.default.pushAlert("Success", overageExempt ? "Subscription exempted from SMS overage" : "SMS overage billing re-enabled", _alertReducer.AlertTypes.SUCCESS)
      setSubscription(firstSubscription(result))
      closeOverageExemptModal()
    }).catch(err => {
      _untypedAlert.pushUntypedAlert.call(void 0, "Failure", "Failed to update overage exemption")
      _log.log.error(err)
    })
  }

  const openOverageExemptModal = () => {
    setOverageExemptModalOpen(true)
  }

  const openUpdateSubscriptionModal = () => {
    setUpdateSubscriptionModalOpen(true)
  }

  const openAttachOrgToSubscriptionModal = () => {
    setAttachOrgToSubscriptionModalOpen(true)
  }

  const openSubscriptionOrgSettingsModal = () => {
    setSubscriptionOrgSettingsModalOpen(true)
  }

  const openDeletePatient = (patientkey) => {
    setPatientToDelete(patientkey)
    setDeletePatientModalOpen(true)
  }

  const closeDeletePatient = _react.useCallback.call(void 0, () => {
    setPatientToDelete(null)
    setDeletePatientModalOpen(false)
  }, [])

  const openMoveUserModal = () => {
    setMoveUserModalOpen(true)
  }

  const closeMoveUserModal = _react.useCallback.call(void 0, () => {
    setMoveUserModalOpen(false)
  }, [])

  const currentUserKey = currentUser.UserKey
  const openSupportChat = _react.useCallback.call(void 0, (userKey) => {
    _supportChat.openSupportChatWithUser.call(void 0, userKey, currentUserKey)
      .catch(err => {
        _actions2.default.pushAlert("Error", "Failed to open support chat", _alertReducer.AlertTypes.ERROR)
        _log.log.error(err)
      })
  }, [currentUserKey])

  const closeTeamPhoneAssigner = _react.useCallback.call(void 0, () => setTeamPhoneAssignerOpen(false), [])

  if (org) {
    const userRows = users.map((user) => _react2.default.createElement(UserResult, { user: user, orgKey: org.OrgKey,
                                                     key: user.UserKey,
                                                     openSupportChat: openSupportChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 604}}))
    const patientRows = patients.map((patient) => _react2.default.createElement(PatientResult, {
        delete: () => openDeletePatient(patient.PatientKey), patient: patient, key: patient.PatientKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 607}}))
    const relationshipRows = relationships.map((rel) => _react2.default.createElement(RelationshipResult, { relationship: rel, key: rel.TrustedOrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 609}}))
    const phoneRows = Object.values(phones).map(p => {
      // SAFETY: the `in` test guarantees the entry.
      const teamName = p.AssignedToKey in teams ? (teams[p.AssignedToKey] ).Name : "Nothing"
      return (
        _react2.default.createElement(_SuperTableTR2.default, { key: p.PhoneKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 614}}
          , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 615}}, p.Number)
          , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 616}}, teamName)
          , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 617}}
            , _react2.default.createElement(SuperTeamPhoneAssigned, {
              isOpen: teamPhoneAssignerOpen && teamPhoneAssignerNumber === p.PhoneKey,
              orgKey: org.OrgKey,
              orgTeams: teams,
              phoneKey: p.PhoneKey,
              teamKey: p.AssignedToKey,
              onClose: closeTeamPhoneAssigner,
              onSuccess: loadOrg, __self: this, __source: {fileName: _jsxFileName, lineNumber: 618}}
            )
            , _react2.default.createElement('button', { className: "blmh-button", onClick: () => {
              setTeamPhoneAssignerOpen(true)
              setTeamPhoneAssignerNumber(p.PhoneKey)
            }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 627}}, "Assign")
            , " "
            , _react2.default.createElement('button', { className: "blmh-button red" , onClick: () => removePhone(p.PhoneKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 632}}, "Release")
          )
        )
      )
    })

    // SAFETY: kept from the class: an owner missing from the settings throws
    // when the subscription section renders.
    const ownerSettings = (subscription ? subscription.SubscriptionOrgSettings[subscription.OrgOwnerKey] : undefined) 

    return (
        _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 643}}
          , _react2.default.createElement(_Modal2.default, {
            isOpen: deletePatientModalOpen,
            onClose: closeDeletePatient,
            title: "DELETE PATIENT FOR REAL"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 644}}

            , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 649}}, "Are you sure you want to delete this patient?"

            )
            , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 652}}, "You have to manually fix it in the database to undo it."

            )
            , _react2.default.createElement(_Modal.ModalControls, {
              secondaryBtnLabel: "Cancel",
              onSecondaryBtnClick: closeDeletePatient,
              primaryBtnLabel: "Delete",
              primaryBtnTheme: "danger",
              onPrimaryBtnClick: deletePatient, __self: this, __source: {fileName: _jsxFileName, lineNumber: 655}}
            )
          )
          , _react2.default.createElement(_SuperTeamModal2.default, {
              open: createTeamModalOpen,
              onClose: closeCreateTeamModal,
              onSubmit: createTeam, __self: this, __source: {fileName: _jsxFileName, lineNumber: 663}})
          , _react2.default.createElement(_SuperMoveUserToAnotherOrgModal2.default, {
              currentOrgKey: org.OrgKey,
              users: users,
              open: moveUserModalOpen,
              onClose: closeMoveUserModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 667}}
          )

          , subscription ? (_react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement(_SuperSubscriptions.SuperUpdateSubscriptionModal, {
                currentOrgKey: org.OrgKey,
                open: updateSubscriptionModalOpen,
                onClose: closeUpdateSubscriptionModal,
                subscription: subscription,
                onSubmit: updateSubscription, __self: this, __source: {fileName: _jsxFileName, lineNumber: 675}}
            )
            , _react2.default.createElement(_SuperSubscriptions.SuperAttachOrgToOtherSubscriptionModal, {
                currentOrgKey: org.OrgKey,
                open: attachOrgToSubscriptionModalOpen,
                onClose: closeAttachOrgToSubscriptionModal,
                onSubmit: attachOrgToNewSubscription, __self: this, __source: {fileName: _jsxFileName, lineNumber: 682}}
            )
            , _react2.default.createElement(_SuperSubscriptions.SuperUpdateSubscriptionOrgSettingsModal, {
                orgKey: org.OrgKey,
                subscription: subscription,
                open: subscriptionOrgSettingsModalOpen,
                onClose: closeSubscriptionOrgSettingsModal,
                onSubmit: updateSubscriptionOrgSettings, __self: this, __source: {fileName: _jsxFileName, lineNumber: 688}}
            )
            , _react2.default.createElement(_SuperSubscriptions.SuperSubscriptionOverageExemptModal, {
                subscription: subscription,
                open: overageExemptModalOpen,
                onClose: closeOverageExemptModal,
                onSubmit: setSubscriptionOverageExempt, __self: this, __source: {fileName: _jsxFileName, lineNumber: 695}}
            )
          )) : null

          , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 703}}
            , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 704}}, "Properties")
            , _react2.default.createElement('dl', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 705}}
              , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 706}}, "Org Key" )
              , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 707}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 707}}, org.OrgKey))
              , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 708}}, "Name")
              , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 709}}, org.Name)
              , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 710}}, "Verified")
              , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 711}}, org.Verified ? 'yes' : 'no')
              , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 712}}, "Features")
              , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 713}}
                ,  org.EnabledFeatures.length > 0
                  ? _react2.default.createElement('ul', { className: "superuser--feature-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 715}},  org.EnabledFeatures.map((feature) => _react2.default.createElement('li', { key: feature, __self: this, __source: {fileName: _jsxFileName, lineNumber: 715}}, feature)) )
                  : _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 716}}, "None")
                
              )
            )
            , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 720}}, _react2.default.createElement('a', { href: "/#/super/orgs/" + org.OrgKey + "/edit", className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 720}}, "Edit"))
          )

          , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 723}}
            , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 724}}, "Phone Numbers" )
            ,  Object.keys(phones).length > 0 ?
              _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 726}}
                , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 727}}
                , _react2.default.createElement(_SuperTableTR2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 728}}
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 729}}, "Number")
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 730}}, "Assigned to" )
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 731}}, " ")
                )
                )
                , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 734}}
                , phoneRows
                )
              )
              :
              _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 739}}, "None")
            
            , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 741}}, _react2.default.createElement('button', { onClick: openPhoneChooser, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 741}}, "Issue Number" ))
            ,  phoneChooserOpen ? _react2.default.createElement(SuperPhoneChooser, { orgKey: orgKey, open: phoneChooserOpen, onClose: closePhoneChooser, __self: this, __source: {fileName: _jsxFileName, lineNumber: 742}} ) : null 
          )

          , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 745}}
            , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 746}}, "Members")
            ,  users.length > 0 ?
              _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 748}}
                , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 749}}
                , _react2.default.createElement(_SuperTableTR2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 750}}
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 751}}, "User Key" )
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 752}}, "First Name" )
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 753}}, "Last Name" )
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 754}}, "Title")
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 755}}, "Role")
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 756}}, "Pending")
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 757}}, "Activated")
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 758}}, "Deleted")
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 759}}, " ")
                )
                )
                , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 762}}
                , userRows
                )
              )
              :
              _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 767}}, "None")
            
            , _react2.default.createElement('form', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 769}}
              , _react2.default.createElement('legend', { className: "superuser--legend", __self: this, __source: {fileName: _jsxFileName, lineNumber: 770}}, "Bulk Invite Users"  )
              , _react2.default.createElement('input', { type: "file", id: "userList", onChange: updateUserList, __self: this, __source: {fileName: _jsxFileName, lineNumber: 771}} ), "Invited by "
                , _react2.default.createElement('input', { type: "text", id: "by", onChange: updateInviteBy, placeholder: "UserKey", __self: this, __source: {fileName: _jsxFileName, lineNumber: 772}} ), ' '
              , _react2.default.createElement('button', { onClick: bulkInvite, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 773}}, "Invite")
            )
            , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 775}}
              , _react2.default.createElement('button', { onClick: openMoveUserModal, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 776}}, "Move Users" )
            )
          )

          , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 780}}
            , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 781}}, "Patients")
            ,  patients.length > 0 ?
              _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 783}}
                , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 784}}
                  , _react2.default.createElement(_SuperTableTR2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 785}}
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 786}}, "Patient Key" )
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 787}}, "MRN")
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 788}}, "First Name" )
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 789}}, "Last Name" )
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 790}}, "Date of Birth"  )
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 791}}, "Phone")
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 792}}, "Email")
                    , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 793}}, ' ')
                  )
                )
                , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 796}}
                  , patientRows
                )
              )
              :
              _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 801}}, "None")
            
            , _react2.default.createElement('form', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 803}}
              , _react2.default.createElement('legend', { className: "superuser--legend", __self: this, __source: {fileName: _jsxFileName, lineNumber: 804}}, "Bulk Import Patients (first_name, last_name, mrn, email, phone)"       )
              , _react2.default.createElement('input', { type: "file", id: "patientList", onChange: updatePatientList, __self: this, __source: {fileName: _jsxFileName, lineNumber: 805}}), "Invited by "
                , _react2.default.createElement('input', { type: "text", id: "imported_by", onChange: updateImportedBy, placeholder: "UserKey", __self: this, __source: {fileName: _jsxFileName, lineNumber: 806}}), ' '
              , _react2.default.createElement('button', { onClick: bulkPatientImport, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 807}}, "Invite")
            )
          )

          , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 811}}
            , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 812}}, "Teams")
            , _react2.default.createElement(_SuperTeamTable2.default, { teams: teams, buttonText: "Create Team" , onButton: openCreateTeamModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 813}})
          )

          , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 816}}
            , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 817}}, "Relationships")
            ,  relationships.length > 0 ?
              _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 819}}
                , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 820}}
                , _react2.default.createElement(_SuperTableTR2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 821}}
                  , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 822}}, "Trusted Org" )
                )
                )
                , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 825}}
                , relationshipRows
                )
              )
              :
              _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 830}}, "None")
            
          )

          , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 834}}
            , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 835}}, "Subscriptions")
            ,  subscription ?
              _react2.default.createElement(_react2.default.Fragment, null
                , _react2.default.createElement('dl', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 838}}
                  , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 839}}, "Subscription Key" )
                  , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 840}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 840}}, subscription.SubscriptionKey))
                  , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 841}}, "Subscription Type" )
                  , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 842}}, subscription.SubscriptionType)
                  , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 843}}, "SMS Overage" )
                  , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 844}}, subscription.OverageExempt ? "Exempt — never billed" : "Billed at renewal")
                  , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 845}}, "Org Owner" )
                  , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 846}}, ownerSettings.Name)
                  , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 847}}, "Attached Orgs" )
                  ,  Object.values(subscription.SubscriptionOrgSettings).map(s =>
                      _react2.default.createElement('dd', { key: s.OrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 849}}, s.Name, " - "  , s.BloomTextProfessional ? "Team Chat" : "Starter", " " , s.PatientMessaging && "plus SMS Messaging"))
                  
                  ,  subscription.StripeSubscriptionID ? _react2.default.createElement(_react2.default.Fragment, null
                      , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 852}}, "Stripe SubscriptionID" )
                      , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 853}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 853}}, subscription.StripeSubscriptionID))
                    ) : null
                  
                  ,  subscription.StripeCustomerID ? _react2.default.createElement(_react2.default.Fragment, null
                      , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 857}}, "Stripe CustomerID" )
                      , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 858}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 858}}, subscription.StripeCustomerID))
                    ) : null
                  
                )
                , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 862}}
                  , _react2.default.createElement('button', { onClick: openUpdateSubscriptionModal, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 863}}, "Update Subscription Details"  ), ' '
                  , _react2.default.createElement('button', { onClick: openAttachOrgToSubscriptionModal, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 864}}, "Merge Subscriptions" ), ' '
                  , _react2.default.createElement('button', { onClick: openSubscriptionOrgSettingsModal, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 865}}, "Subscription Org Settings"  ), ' '
                  , _react2.default.createElement('button', { onClick: openOverageExemptModal, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 866}}, "SMS Overage Exemption"  )
                )
              )
              :
              _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 870}}, "None")
            
          )
        )
    )
  } else {
    return null
  }
})

exports. default = SuperOrganizationScreen
